import useLoadMaintenanceEvents from "modules/companies/tabs/hooks/useLoadMaintenanceEvents";

const WithMaintenanceEvents = (WrappedComponent) => {
  return function Wrapper(props) {
    const { list, isListLoading, setIsListLoading, loadMaintenanceEvents } = useLoadMaintenanceEvents(props.httpRequest, { maintenance: props.maintenance.id });
    const maintenanceEvents = {
      list,
      isListLoading,
      setIsListLoading,
      loadMaintenanceEvents,
    };
    return <WrappedComponent {...props} maintenanceEvents={maintenanceEvents} />;
  };
};
export default WithMaintenanceEvents;